export default __webpack_public_path__ + "static/media/icon-facebook.ebb7bee4.svg";